import { rebind, merge } from "../utils";

import { standardDeviation } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "StandardDeviation";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.standardDeviation);

  const underlyingAlgorithm = standardDeviation();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.standardDeviation = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor()) throw new Error("Set accessor");
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
